import React, { useState } from "react";
import { Modal, Confirm } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

export function BasicModal({ show, close, title, children, size = "tiny" }) {
  // OJO: el texto de la confirmacion esta HOY EN INGLES en produccion. Se
  // extrae tal cual, sin reescribirlo: corregir la copia es una decision de
  // producto, no de la extraccion. Ver informe.
  const { t } = useTranslation("misc");
  const [confirmOpen, setConfirmOpen] = useState(false);

  // Handle the close attempt
  const handleCloseAttempt = () => {
    setConfirmOpen(true); // Show the confirmation dialog
  };

  // Handle actual close
  const handleConfirmClose = () => {
    setConfirmOpen(false); // Close the confirmation dialog
    close(); // Close the modal
  };

  // Handle cancel close
  const handleCancelClose = () => {
    setConfirmOpen(false); // Just close the confirmation dialog
  };

  return (
    <>
      <Modal closeIcon open={show} onClose={handleCloseAttempt} size={size}>
        {title && <Modal.Header>{title}</Modal.Header>}
        <Modal.Content>{children}</Modal.Content>
      </Modal>
      <Confirm
        open={confirmOpen}
        onCancel={handleCancelClose}
        onConfirm={handleConfirmClose}
        content={t("modal.closeConfirm")}
      />
    </>
  );
}
